import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { Paper } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import {
  CHART_TYPE_FORECAST,
  CHART_TYPE_HISTORICAL,
} from 'helpers/environmentMonitor'
import CircleLoader from 'components/Loading/CircleLoader'
import messages from './translate'

class ChartWrapper extends Component {
  renderCharts = () => {
    const { loader, children } = this.props

    return (
      <>
        <CircleLoader loading={loader} />
        {children}
      </>
    )
  }

  render() {
    const {
      intl: { formatMessage },
      className,
      chartType,
      chartTypeChange,
      wrapTitle,
    } = this.props
    const forecastTitle = `12 ${formatMessage(messages.hourForecast)}`
    const historicalTitle = wrapTitle || formatMessage(messages.lastHours)

    return (
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <Paper className={`chart-wrap ${className}`}>
          <div className="wrap-header">
            <div className="title">
              {chartType === CHART_TYPE_FORECAST
                ? forecastTitle
                : historicalTitle}
            </div>
            <button
              type="button"
              onClick={chartTypeChange}
              className="type-toggle"
              value={
                chartType === CHART_TYPE_FORECAST
                  ? CHART_TYPE_HISTORICAL
                  : CHART_TYPE_FORECAST
              }>
              {chartType === CHART_TYPE_FORECAST
                ? formatMessage(messages.viewHistory)
                : formatMessage(messages.viewForecast)}
            </button>
          </div>
          <div className="wrap-content">
            <div className="content-chart">{this.renderCharts()}</div>
          </div>
        </Paper>
      </Grid>
    )
  }
}

export default injectIntl(ChartWrapper)
